import { combineReducers } from 'redux';
import { ERROR, RECEIVE, REQUEST, SET } from './constants';
import valueReducer from '../../../common/reducers/valueReducer';
import booleanReducer from '../../../common/reducers/booleanReducer';
import {
  CHANGE_SHOP,
  RESET_SHOP,
} from '../../../auth/constants';

const response = valueReducer({}, SET, [CHANGE_SHOP, RESET_SHOP]);

const isFetching = booleanReducer(false, [REQUEST], [RECEIVE, ERROR]);

const reducer = combineReducers({
  response,
  isFetching,
});

export default reducer;
